import { portfolio } from "../data/portfolio";

export function Hero() {
  const { identity } = portfolio;
  const [first, ...rest] = identity.name.split(" ");

  return (
    <section id="top" className="m3-hero">
      <div className="md-container">
        <div className="m3-hero__grid reveal">
          <div className="m3-hero__primary">
            <div className="md-label-l" style={{ color: "var(--md-sys-color-primary)" }}>
              {identity.role}
            </div>
            <h1 className="m3-hero__display">
              <span>{first}</span>
              <br />
              <span className="accent">{rest.join(" ")}.</span>
            </h1>
            <p className="m3-hero__dek">{identity.tagline}</p>

            <div className="m3-hero__chips" style={{ marginTop: 8 }}>
              <span className="md-chip m3-hero__chip">
                <span className="material-symbols-rounded icon-20">place</span>
                {identity.location}
              </span>
              <span className="md-chip m3-hero__chip">
                <span
                  className="material-symbols-rounded icon-20"
                  style={{ color: "var(--md-sys-color-tertiary)" }}
                >
                  fiber_manual_record
                </span>
                Available · Fall 2026
              </span>
            </div>

            <div className="m3-hero__actions" style={{ marginTop: 16 }}>
              <a className="md-fab md-fab--primary" href={identity.links.cv} download>
                <span className="material-symbols-rounded">download</span>
                Download résumé
              </a>
              <a className="md-fab md-btn--outlined" href={"mailto:" + identity.email}>
                <span className="material-symbols-rounded">mail</span>
                Get in touch
              </a>
            </div>
          </div>

          <div className="m3-hero__side">
            <div className="m3-hero__avatar md-card md-card--filled" style={{ minHeight: 280 }}>
              <img
                src={`${import.meta.env.BASE_URL}Mohan.jpg`}
                alt={identity.name}
                style={{
                  width: "100%",
                  height: "100%",
                  minHeight: 280,
                  objectFit: "cover",
                }}
              />
            </div>
            <div className="m3-hero__meta-row">
              <div className="m3-hero__meta-card md-card md-card--tonal-sec">
                <div className="md-label-m m3-hero__meta-label">Previously</div>
                <div className="md-title-m m3-hero__meta-value">Airbus</div>
                <div className="md-body-s dim">Generative AI Intern · BLR </div>
              </div>
              <div className="m3-hero__meta-card md-card md-card--tonal-ter">
                <div className="md-label-m m3-hero__meta-label">Goal</div>
                <div className="md-title-m m3-hero__meta-value">AI/ML Engineer</div>
                <div className="md-body-s dim">Efficient &amp; reliable AI systems</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
